import {
  createInstallationPresentation,
  resolveInstallationPresentation,
} from 'ui.shipaid.com/renderers/checkout-plus-legacy';
import type { PresentationResult, SamplePricingStatus } from 'ui.shipaid.com/renderers/checkout-plus-legacy';
import type { ResolvedLegacySampleV2 } from 'types/legacyCheckoutPreview';
import { parseInstallationDraft } from './installationPresentation';
import { resolveLegacySample } from './legacyCheckoutPreview';

export type CustomizedSampleResult = Exclude<PresentationResult, { status: 'available' }> |
  (Extract<PresentationResult, { status: 'available' }> & { sample: ResolvedLegacySampleV2 });

export function resolveCustomizedInstallationSample(
  input: unknown, preferences: unknown, flags: Parameters<typeof resolveLegacySample>[1],
  options: { pricingStatus: SamplePricingStatus } = { pricingStatus: 'sealed-sample' },
): CustomizedSampleResult {
  const unavailable: CustomizedSampleResult = { status: 'unavailable', message: 'Sample customization unavailable. Try again.' };
  try {
    // Immutable sample admission remains the first boundary, without weakened matching.
    const sample = resolveLegacySample(input, flags);
    const draft = parseInstallationDraft(preferences);
    if (sample.status !== 'available' || !draft || !options ||
      Object.keys(options).length !== 1 || !Object.prototype.hasOwnProperty.call(options, 'pricingStatus')) return unavailable;
    const appearance = draft.schemaVersion === 2 ? draft.appearance :
      createInstallationPresentation(draft.appearance.mode === 'inherit-theme' ? 'match-theme' : 'preserve-existing');
    const result = resolveInstallationPresentation(appearance, sample.snapshot,
      { origin: 'synthetic-sample', locale: sample.sample.locale, pricingStatus: options.pricingStatus });
    return result.status === 'available' ? Object.freeze({ ...result, sample: sample.sample }) : result;
  } catch { return unavailable; }
}
